import { jsxs as b, jsx as r } from "react/jsx-runtime";
import { Flex as f } from "@chakra-ui/react";
import { SelectBase as m } from "../../../Select/SelectBase.mjs";
import "../../../Button/Button.mjs";
import { IconButton as l } from "../../../Button/IconButton.mjs";
import "../../../Button/ButtonGroup.mjs";
import { useMemo as y } from "react";
import { getYears as d } from "../utils/getYears/getYears.mjs";
import { ChevronLeftIcon as C, ChevronRightIcon as x } from "../../../../icons/componentIcons.mjs";
const i = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], z = i.map((t) => ({
  label: t,
  value: t
})), k = ({
  date: t,
  decreaseMonth: s,
  increaseMonth: p,
  nextMonthButtonDisabled: u,
  prevMonthButtonDisabled: c,
  changeYear: h,
  changeMonth: v,
  minDate: n,
  maxDate: a,
  dataTestId: e
}) => {
  const g = y(() => d({
    minDate: n,
    maxDate: a,
    currentYear: (/* @__PURE__ */ new Date()).getFullYear()
  }).map((o) => ({
    label: o.toString(),
    value: o.toString()
  })), [n, a]);
  return /* @__PURE__ */ b(f, { alignItems: "center", gap: 1, justifyContent: "space-between", children: [
    /* @__PURE__ */ r(
      l,
      {
        size: "sm",
        "aria-label": "Previous month",
        icon: /* @__PURE__ */ r(C, { variant: "light", size: "md" }),
        "data-testid": e ? `${e}-prev` : void 0,
        isDisabled: c,
        onClick: s,
        variant: "ghost"
      }
    ),
    /* @__PURE__ */ r(
      m,
      {
        textStyle: "bodyBold",
        minWidth: "125px",
        variant: "filled",
        "data-testid": e ? `${e}-month` : void 0,
        size: "sm",
        name: "month",
        value: t ? i[t.getMonth()] : "",
        onChange: ({ target: { value: o } }) => v(i.indexOf(o)),
        options: z
      }
    ),
    /* @__PURE__ */ r(
      m,
      {
        textStyle: "bodyBold",
        variant: "filled",
        size: "sm",
        name: "year",
        "data-testid": e ? `${e}-year` : void 0,
        value: t ? `${t.getFullYear()}` : "",
        onChange: ({ target: { value: o } }) => h(+o),
        options: g
      }
    ),
    /* @__PURE__ */ r(
      l,
      {
        size: "sm",
        "aria-label": "Next month",
        icon: /* @__PURE__ */ r(x, { variant: "light", size: "md" }),
        "data-testid": e ? `${e}-next` : void 0,
        isDisabled: u,
        onClick: p,
        variant: "ghost"
      }
    )
  ] });
};
export {
  k as CustomHeader
};
